import { Container, Heading, Link, Navbar, Text } from '@doist/marketist';
import { Image } from 'components/blog-posts/image/image';
import { Button } from 'components/button';
import Interpolate from 'components/Interpolate/Interpolate';
import { useTranslation } from 'next-i18next';
import Footer from '../Footer/Footer';
export type NotFoundProps = {
  title: string;
  description: React.ReactNode;
  cta: string;
};
export function NotFound() {
  const {
    t
  } = useTranslation('common');
  return <>
            <Container data-sentry-element="Container" data-sentry-source-file="not-found.tsx">
                <Navbar data-sentry-element="Navbar" data-sentry-source-file="not-found.tsx">
                    <Navbar.Section data-sentry-element="unknown" data-sentry-source-file="not-found.tsx">
                        <Navbar.Logo aria-label="Todoist" href="/home" data-sentry-element="unknown" data-sentry-source-file="not-found.tsx" />
                    </Navbar.Section>
                </Navbar>
            </Container>
            <Container tag="main" style={{
      textAlign: 'center'
    }} className="pbe-48 sm-pbe-64 md-pbe-96" data-sentry-element="Container" data-sentry-source-file="not-found.tsx">
                <Image src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/errors/404.jpg`} width={428} height={235} priority alt="" data-sentry-element="Image" data-sentry-source-file="not-found.tsx" />
                <Heading level="1" size="major-base" className="mbs-48" data-sentry-element="Heading" data-sentry-source-file="not-found.tsx">
                    {t('notFound.title')}
                </Heading>
                <Text size="body-lg" className="mbs-8" data-sentry-element="Text" data-sentry-source-file="not-found.tsx">
                    <Interpolate t={t} i18nKey="notFound.copyV2" mapping={{
          link: <Link href="/help" />
        }} data-sentry-element="Interpolate" data-sentry-source-file="not-found.tsx" />
                </Text>
                <Button href="/home" size="large" className="mbs-32" data-sentry-element="Button" data-sentry-source-file="not-found.tsx">
                    {t('notFound.cta')}
                </Button>
            </Container>
            <Footer utm_campaign="not_found" data-sentry-element="Footer" data-sentry-source-file="not-found.tsx" />
        </>;
}